import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4bc60762"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("All")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Favourites")
const _hoisted_3 = {
  key: 0,
  id: "card-list"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Add to ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Favourites ")
const _hoisted_7 = {
  key: 1,
  id: "card-list"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Remove ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderMain = _resolveComponent("HeaderMain")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_skeleton_text = _resolveComponent("ion-skeleton-text")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_item_option = _resolveComponent("ion-item-option")!
  const _component_ion_item_options = _resolveComponent("ion-item-options")!
  const _component_ion_item_sliding = _resolveComponent("ion-item-sliding")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_HeaderMain, {
        "page-title": "Agenda",
        "default-href": "/home",
        "icon-filter": true,
        "callback-filter": _ctx.handleFilterModal
      }, null, 8, ["callback-filter"]),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, { color: "primary" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_segment, {
                modelValue: _ctx.agendaSegmentVal,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.agendaSegmentVal) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_segment_button, { value: "all" }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_segment_button, { value: "favorites" }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_ion_toolbar, { color: "primary" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_searchbar, {
                "show-cancel-button": "focus",
                color: "light",
                modelValue: _ctx.search,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (_ctx.agendaSegmentVal === 'all')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (!_ctx.searchAgenda || _ctx.searchAgenda.length <= 0)
                  ? (_openBlock(), _createBlock(_component_ion_list, {
                      key: 0,
                      class: "ion-margin-vertical"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (item) => {
                          return _createVNode(_component_ion_item, {
                            key: item,
                            class: "ion-margin-vertical"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("h3", null, [
                                    _createVNode(_component_ion_skeleton_text, {
                                      animated: "",
                                      style: {"width":"80%"}
                                    })
                                  ]),
                                  _createElementVNode("p", null, [
                                    _createVNode(_component_ion_skeleton_text, {
                                      animated: "",
                                      style: {"width":"30%"}
                                    })
                                  ]),
                                  _createElementVNode("p", null, [
                                    _createVNode(_component_ion_skeleton_text, {
                                      animated: "",
                                      style: {"width":"20%"}
                                    })
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1024)
                        }), 64))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchAgenda, (item) => {
                  return (_openBlock(), _createBlock(_component_ion_item_sliding, {
                    key: item.id,
                    class: "ion-activatable ripple-parent",
                    style: _normalizeStyle([{ borderLeft: `5px solid ${item.colour}` }])
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_list, { class: "ion-no-padding" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, {
                            onClick: () => _ctx.router.push(`/agenda/${item.id}`)
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_ripple_effect),
                              _createVNode(_component_ion_label, { class: "title ion-text-wrap" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.name) + " ", 1),
                                  _createElementVNode("h3", null, _toDisplayString(_ctx.fireBaseTime(item.start_date)) + " - " + _toDisplayString(_ctx.fireBaseTime(item.end_date)), 1),
                                  _createElementVNode("p", null, _toDisplayString(item.roomName), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_ion_item_options, { side: "end" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_item_option, {
                                "icon-only": "",
                                color: "primary"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, {
                                    class: "flex flex-column ion-align-items-center ion-justify-content-center ion-text-center",
                                    onClick: ($event: any) => (_ctx.addToFavourite(item))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        class: "size",
                                        icon: _ctx.addCircleSharp
                                      }, null, 8, ["icon"]),
                                      _hoisted_4,
                                      _hoisted_5,
                                      _hoisted_6
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["style"]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (!_ctx.favouriteAgenda || _ctx.favouriteAgenda.length <= 0)
                  ? (_openBlock(), _createBlock(_component_EmptyState, {
                      key: 0,
                      title: "agenda"
                    }))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.favouriteAgenda, (item) => {
                  return (_openBlock(), _createBlock(_component_ion_item_sliding, {
                    key: item.id,
                    class: "ion-activatable ripple-parent",
                    style: _normalizeStyle([{ borderLeft: `5px solid ${item.colour}` }])
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_list, { class: "ion-no-padding" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, {
                            onClick: () => _ctx.router.push(`/agenda/${item.id}`)
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_ripple_effect),
                              _createVNode(_component_ion_label, { class: "title ion-text-wrap" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.name) + " ", 1),
                                  _createElementVNode("h3", null, _toDisplayString(_ctx.fireBaseTime(item.start_date)) + " - " + _toDisplayString(_ctx.fireBaseTime(item.start_date)), 1),
                                  _createElementVNode("p", null, _toDisplayString(item.roomName), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_ion_item_options, { side: "end" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_item_option, {
                                "icon-only": "",
                                color: "danger"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, {
                                    class: "flex flex-column ion-align-items-center ion-justify-content-center ion-text-center",
                                    onClick: ($event: any) => (_ctx.removeFromFavourite(item))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        class: "size",
                                        icon: _ctx.trashOutline
                                      }, null, 8, ["icon"]),
                                      _hoisted_8
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["style"]))
                }), 128))
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}